import s from './style.module.scss';
import { Display } from '@/components/Display/Display';
import { useState } from 'react';
// import choseImg from '@/assets/images/web/courseRecommend/chose.webp';
import moment from 'moment';
import GrtButton from '@/components/Mobile/GrtButton';
import { CloseOutline } from 'antd-mobile-icons';

import { goDetailPage, handleCheckBusinessStatus } from '@/utils/Page/personalRecommend';
const getTime = (end_state, start_time, end_time) => {
    if (end_state === 2) {
        return '长期有效';
    }
    if (start_time && end_time) {
        return moment(start_time).format('YYYY-MM-DD HH:mm:ss') + ' 至 ' + moment(end_time).format('YYYY-MM-DD HH:mm:ss');
    }
    return null;
};
const ChoseProject = (props) => {
    const [choseItem, setChoseItem] = useState({}); //当前选择的
    const { list, onClose } = props;
    const onClick = async () => {
        let data = {
            business_id: choseItem.business_id,
            template_id: choseItem.template_id
        };
        let res = await handleCheckBusinessStatus(data);
        if (res) {
            onClose();
        }
    };
    return (
        <div className={s['chose-list-box']}>
            <div className={s['all-title']}>
                <div className={s['left']}>选择项目</div>
                <span onClick={onClose}>
                    <CloseOutline />
                </span>
            </div>
            <div className={s['tip-text']}>该点播课存在多个项目下，请任选一个进行学习</div>
            <div className={s['chose-list-wrap']}>
                {list.map((ele, index) => {
                    return (
                        <div
                            key={index}
                            onClick={() => {
                                setChoseItem(ele);
                            }}
                            className={s['chose-item']}
                            data-active={choseItem.business_id === ele.business_id}
                        >
                            <Display show={choseItem.business_id === ele.business_id}>
                                {/* <img className={s['check-img']} src={choseImg} alt="" /> */}
                                <div className={s['check-img']}></div>
                            </Display>

                            <div className={s['title']}>{ele.business_name}</div>
                            <div className={s['time']}>{getTime(ele.end_state, ele.start_time, ele.end_time) || ''}</div>
                        </div>
                    );
                })}
            </div>
            <div style={{ textAlign: 'center' }}>
                <GrtButton disabled={!choseItem.business_id} onClick={onClick} className={s['chose-button']} color="primary">
                    确定
                </GrtButton>
            </div>
        </div>
    );
};

export default ChoseProject;
